import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {Provider} from "react-redux";
import store from './components/redux/store';
import ApiEndpoint from "./services/ApiEndpoint";

// Start connecting to the API server now, while the page's code is still loading, so the first request
// doesn't also have to wait for the lookup and secure handshake
const apiPreconnect = document.createElement("link");
apiPreconnect.rel = "preconnect";
apiPreconnect.href = new URL(new ApiEndpoint().setEnvironmentURL()).origin;
apiPreconnect.crossOrigin = "anonymous";
document.head.appendChild(apiPreconnect);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    // <React.StrictMode>
    <Provider store={store}>
        <main className="light text-foreground bg-background min-h-screen">
            <App/>
        </main>
    </Provider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();